"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Menu = _interopRequireWildcard(require("../Menu"));
var _usePopoverState2 = _interopRequireDefault(require("../hooks/usePopoverState"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    item: {
      minWidth: 200
    },
    button: {
      borderRadius: 50,
      boxShadow: 'none',
      paddingLeft: theme.spacing(4),
      textTransform: 'none',
      fontSize: theme.typography.body1.fontSize,
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.05),
      color: theme.palette.primary.main,
      justifyContent: 'space-between',
      '&:hover, &:active, &:focus': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.08),
        boxShadow: 'none'
      }
    },
    small: {
      maxWidth: 220
    }
  };
});
var SelectButton = function SelectButton(props) {
  var label = props.label,
    items = props.items,
    small = props.small;
  var classes = useStyles();
  var _usePopoverState = (0, _usePopoverState2["default"])(),
    buttonProps = _usePopoverState.buttonProps,
    popoverProps = _usePopoverState.popoverProps;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(small && classes.small)
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    "aria-haspopup": "true",
    variant: "contained",
    className: classes.button,
    endIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], null),
    fullWidth: true
  }, buttonProps), label), /*#__PURE__*/_react["default"].createElement(_Menu["default"], _extends({
    keepMounted: true,
    getContentAnchorEl: null
  }, popoverProps, {
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    }
  }), items.map(function (_ref) {
    var optionLabel = _ref.label,
      _onClick = _ref.onClick;
    return /*#__PURE__*/_react["default"].createElement(_Menu.MenuItem, {
      key: optionLabel,
      className: classes.item,
      onClick: function onClick() {
        _onClick();
        popoverProps.onClose();
      }
    }, optionLabel);
  })));
};
SelectButton.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    onClick: _propTypes["default"].func.isRequired
  })).isRequired,
  label: _propTypes["default"].string.isRequired,
  small: _propTypes["default"].bool
};
SelectButton.defaultProps = {
  small: false
};
var _default = exports["default"] = SelectButton;